<template>
  <div class="component-map__bottom">
    <div class="component-map__bottom__left">
      <Button
        label="Ver tutorial"
        @click="tutorialRef?.open"
      />
      <span class="component-map-bottom__app-version ml-3">{{ appVersion }}</span>
    </div>
    <div class="component-map__bottom__center">
    </div>
    <div class="component-map__bottom__right">
      <span v-if="isGridActive">
        <strong>Cuadrícula geográfica en EPSG 4326 |&nbsp;</strong>
      </span>
      <span
        v-if="!!latLong"
        class="mr-2"
      >
        <strong>{{ latLong }} |</strong>
      </span>
      <span>
        <strong>Zoom:</strong>
        {{ zoom }}
      </span>
    </div>
    <Tutorial
      ref="tutorialRef"
      :dont-show-more-message="true"
      :items="controllerTutorial?.getLikeCorrectArray() ?? []"
      @close="closeTutorial"
      @finish="finishTutorial"
      @before-update="(i) => triggerTutorial(i)"
    />
  </div>
</template>


<script setup>
import {ref, inject, onMounted, computed, watch} from 'vue';
import {useStore} from 'vuex';
import {transform} from 'ol/proj';
import {toStringHDMS} from 'ol/coordinate';
import {getTutorials} from '@/api/visor/tutorials/tutorial.api';
import Button from 'primevue/button';
import Tutorial from '@/components/Tutorial/Tutorial';

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const appLocales = ['es-ES', 'en-UK', 'en-US']; // TODO: Poner en composable o algo
const FORMAT_NUMBER_OPTIONS = {
  style: 'decimal',
  maximumFractionDigits: 0,
};
const formatNumber = new Intl.NumberFormat(appLocales, FORMAT_NUMBER_OPTIONS);

const modelMapRef = inject('modelMapRef');
const controllerTutorial = ref(null);
const tutorialRef = ref();
const appVersion = computed(() => VERSION);
const latLong = computed(() => {
  let res = '';
  if (
    !!modelMapRef?.value?.positionMouse[0] &&
    !!modelMapRef?.value?.positionMouse[1]
  ) {
    const coord = [
      modelMapRef.value.positionMouse[0],
      modelMapRef.value.positionMouse[1],
    ];
    const coord3857 = transform(coord, 'EPSG:3857', 'EPSG:4326');
    res = toStringHDMS(coord3857);
  }
  return res;
});
const zoom = computed(() => formatNumber.format(modelMapRef.value.zoom));
const isGridActive = computed(() => store.getters['userLayers/isGridLayerActive']);
// #endregion

// #region Functions
async function triggerTutorial(index) {
  const menuInfo = controllerTutorial.value?.tutorials[index]?.triggerMenuId;
  const sidebar = controllerTutorial.value?.tutorials[index]?.sidebar;
  if (!sidebar) {
    await store.dispatch('tutorial/toggleSidebar', false);
  }
  if (!!sidebar) {
    await store.dispatch('tutorial/toggleSidebar', true);
  }
  if (!menuInfo) {
    await store.dispatch('app/setDismissableOverlay', true);
  }
  if (!!menuInfo) {
    await store.dispatch('tutorial/openMenu', {menuInfo});
  }
}
async function closeTutorial() {
  await store.dispatch('app/setDismissableOverlay', true);
}
async function finishTutorial() {
  await store.dispatch('app/setDismissableOverlay', true);
  tutorialRef?.value?.close();
}
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  const mock = true;
  controllerTutorial.value = await getTutorials(mock);
});
watch(isGridActive, (newIsGridActive) => {
  isGridActive.value = newIsGridActive;
});
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.component-map__bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $brand__boundingsMap--heightBottom + 1;
  background-color: rgba($brand__color--black, 0.5);
  color: $brand__color--white;

  &__left {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__center {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1%;

    &__text {
      padding: 0px 5px;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
    &__button {
      flex: 0 0 auto;
    }
  }

  &__right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  & > div {
    padding: 0 10px;
  }
}
</style>

<style lang="scss">
.component-map__bottom__dialog__content {
  padding: 0 !important;
  background-color: rgba($brand__color--blue, 0.8) !important;
  color: $brand__color--white;
  display: flex;
}
</style>
